<template>
  <div class="index">
    <Seacher></Seacher>
    <div class="list">
      <div class="list-data">
        <div class="head">Verify Node Information</div>
        <div class="list-height">
          <div
            class="content_center"
            v-for="(transfer, index) in transferList"
            :key="index"
          >
            <div>
              Nick Name<span class="black notranslate">{{
                transfer.name
              }}</span>
            </div>
            <div>
              Address<span
                class="notranslate"
                @click="goDetail('address', transfer.address)"
                >{{ transfer.address }}</span
              >
            </div>
            <div>
              Age<span class="black notranslate">{{ transfer.tradeTime }}</span>
            </div>
          </div>
        </div>
        <div class="block">
          <el-pagination
            background
            small
            :current-page.sync="pageNum"
            layout="prev,pager,next"
            :total="total"
            :page-size="10"
            :pager-count="5"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Seacher from "@/components/m/Seacher.vue";
import { VerifyList } from "../../assets/server/api.js";
import { formatSeconds} from "../../utils/utils.js";
export default {
  components: {
    Seacher,
  },
  data() {
    return {
      pageSize: 1,
      pageNum: 1, 
      total: null,
      count: 0, 
      stakeRate: 0, 
      totalStake: 0, 
      yieldOfStake: 0, 
      allStake: 0, 
      transferList: [],
    };
  },
  computed: {
    getClientTimezone() {
      var oDate = new Date();
      var nTimezone = -oDate.getTimezoneOffset() / 60;
      return nTimezone.toFixed(2);
    },
  },
  created() {
    this.pageNum = this.getContextData("tiaozhuan3") || 1;
  },
  mounted() {
    this.verifierinit();
  },
  destroyed() {
  },
  methods: {
    setContextData: function (key, value) {
      if (typeof value == "string") {
        sessionStorage.setItem(key, value);
      } else {
        sessionStorage.setItem(key, JSON.stringify(value));
      }
    },
    getContextData: function (key) {
      const str = sessionStorage.getItem(key);
      if (typeof str == "string") {
        try {
          return JSON.parse(str);
        } catch (e) {
          return str;
        }
      }
      return;
    },
    async verifierinit() {
      let formData = new FormData();
      let params = {
        pageNum: this.pageNum,
        pageSize: 10,
      };
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }

      var res = await VerifyList(formData);
      this.transferList = res.result.gasList;
     this.total=100;
      var calctimea = new Date();
      let strdatea = Math.floor(calctimea.getTime() / 1000); 
      for (var i = 0; i < this.transferList.length; i++) {
        if (this.transferList[i].name == "") {
          this.transferList[i].name = "Unknown";
        }
        let timestampa = Math.floor(
          this.gltimea(this.transferList[i].tradeTime) / 1000
        ); 
        var s = strdatea - timestampa;
        if (s <= 0) {
          s = 1;
        }
        this.transferList[i].tradeTime = formatSeconds(s);
      }
    },
    add() {
      let _args = arguments;
      let _pointArray = Array.prototype.map.call(_args, (item) => {
        let _itemArray = item.toString().split(".");

        return _itemArray.length > 1 ? _itemArray[1].length : 0;
      });
      let _maxPoint = Math.max.apply(null, _pointArray);
      let _scale = Math.pow(10, _maxPoint);
      return (
        Array.prototype.reduce.apply(_args, [(a, b) => a + b * _scale, 0]) /
        _scale
      );
    },
    handleCurrentChange(currentPage) {
      this.pageNum = currentPage;
      this.setContextData("tiaozhuan3", this.pageNum);
      this.verifierinit();
    },
    goDetail(name, query) {
      switch (name) {
        case "address":
          this.$router.push({
            path: "/m/Address",
            query: { address: query },
          });
          break;
      }
    },
    gltimea(i) {
      const toDate = new Date(i); 
      var d = toDate;
      var localTime = d.getTime();
      var localOffset = d.getTimezoneOffset() * 60000; 
      var utc = localTime + localOffset;
      var offset = this.getClientTimezone;
      var korean = utc + 3600000 * offset;
      var nd = korean;
      return nd;
    },
 
  },
};
</script>

<style lang="less">
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #22252e;
  color: #fff;
  font-size: 24px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 400;
  border: none;
}
.el-pager li {
  margin: 0px 6px !important;
  padding: 0px 6px !important;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev {
  background: none;
  color: #adb0c7;
  width: 10px !important;
}

.el-pagination.is-background .el-pager li {
  padding-left: 6px;
  padding-right: 6px;
  height: 48px;
  margin: 0 10px;
  //background: #3c485c;
  background: none;
  border-radius: 8px;
  opacity: 1;

  font-size: 24px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 48px;

  text-align: center;
}
</style>

<style lang="less" scoped>
.el-pagination {
  padding: 0 !important;
}
@keyframes showLeft {
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}
@keyframes showRight {
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}
@keyframes hideLeft {
  to {
    opacity: 0;
    transform: translateX(-100px);
  }
}
@keyframes hideRight {
  to {
    opacity: 0;
    transform: translateX(100px);
  }
}
@keyframes scaleUp-animation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes scaleDown-animation {
  0% {
    transform: scale(1.25);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.25);
  }
}
.scale {
}
.scale :hover {
  transform: rotate(7deg);
  -ms-transform: rotate(7deg); /* IE 9 */
  -moz-transform: rotate(7deg); /* Firefox */
  -webkit-transform: rotate(7deg); /* Safari  Chrome */
  -o-transform: rotate(7deg); /* Opera */
  color: red;
}

.index {
  width: 750px;
  margin: 110px auto 0px auto;
  background: #000;
  text-align: center;

  .list {
    text-align: center;
    padding-bottom: 80px;

    .list-data {
      margin: 30px auto 0px auto;
      width: 690px;
      background: #232a35;
      border-radius: 24px 24px 24px 24px;
      opacity: 1;
      .head {
        width: 690px;
        height: 100px;
        padding-left: 30px;
        text-align: left;
        font-size: 32px;
        font-family: SF Pro Text-Medium, SF Pro Text;
        font-weight: 500;
        color: rgba(255, 255, 255, 0.9);
        line-height: 100px;
      }
      .list-height {
        min-height: 920px;
        .content_center {
          text-align: left;
          padding: 10px 0px;
          font-size: 28px;
          font-family: SF Pro Text-Medium, SF Pro Text;
          font-weight: 500;
          color: #adb0c7;
          line-height: 36px;
          border-bottom: 1px solid #3c485c;
          margin: 0px 32px;
          div {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-top: 16px;
            font-size: 28px;
            font-family: SF Pro Text-Regular, SF Pro Text;
            font-weight: 400;
          }
          span {
            padding-bottom: 10px;
            text-align: left;
            float: right;
            color: #00a870;
            line-height: 34px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            width: 420px;
          }
          .black {
            height: 44px;
            color: rgba(255, 255, 255, 0.9);
            line-height: 44px;
          }
          .yes {
            color: #1abb8d;
          }
          .no {
            color: #c21111;
          }
          span:nth-child(4) {
            color: #2c3852 !important;
          }
          span:nth-child(5) {
            color: #2c3852 !important;
          }
        }
      }

      .block {
        margin-top: 32px;
        padding-bottom: 32px;
        font-size: 28px;
        font-family: "PingFang SC-中黑体, PingFang SC";
        font-weight: normal;
        color: #adb0c7;
      }
    }
  }
}
</style>
